import React from 'react';
import VibanaMark from './VibanaMark';

/**
 * The inline brand mark, for use beside running text.
 *
 * This file used to be an <img> pointing at a 256px PNG, and its own comment
 * described the artwork as "colorful V" — a different mark from the one the
 * brand now uses. It renders the vector instead, so it is sharp at any size and
 * costs no request.
 */
export default function VibanaWordmark({ size = 24, ...rest }) {
  return (
    <VibanaMark
      size={size}
      style={{ verticalAlign: 'text-bottom', marginRight: 6 }}
      {...rest}
    />
  );
}
